import { Link } from 'react-router-dom';
import { homepageArticles } from '@/mocks/homepage-articles';

export default function ArticleCardsSection() {
  return (
    <section className="bg-background-50 py-14 md:py-20">
      <div className="px-6 md:px-12">
        <div className="text-center mb-10 md:mb-14">
          <span className="text-xs font-semibold tracking-widest uppercase text-foreground-500">
            Articoli SEO
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mt-3">
            Guide e approfondimenti
            <br />
            <span className="text-primary-500">Itaobuy Spreadsheet</span>
          </h2>
          <p className="mt-3 text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            Esplora i nostri articoli approfonditi su Itaobuy Spreadsheet: guide, analisi di sicurezza, confronti e tutorial pratici
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {homepageArticles.map((article) => (
            article.isInternal ? (
              <Link
                key={article.slug}
                to={article.link}
                className="group bg-background-100 rounded-lg overflow-hidden cursor-pointer hover:bg-background-200/70 transition-colors"
              >
                <div className="w-full h-48 md:h-52 overflow-hidden">
                  <img
                    src={article.image}
                    alt={article.title}
                    className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
                <div className="p-4 md:p-5">
                  <span className="inline-block text-xs font-semibold tracking-wider uppercase text-primary-500 bg-primary-50 px-2.5 py-1 rounded-full mb-2">
                    {article.category}
                  </span>
                  <h3 className="font-heading text-base md:text-lg font-bold text-foreground-950 leading-snug group-hover:text-primary-500 transition-colors">
                    {article.title}
                  </h3>
                  <p className="mt-2 text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-3">
                    {article.excerpt}
                  </p>
                  <span className="mt-3 inline-flex items-center gap-1 text-xs font-medium text-primary-500">
                    Leggi articolo
                    <i className="ri-arrow-right-line w-3 h-3 flex items-center justify-center"></i>
                  </span>
                </div>
              </Link>
            ) : (
              <a
                key={article.slug}
                href={article.link}
                target="_blank"
                rel="noopener nofollow"
                className="group bg-background-100 rounded-lg overflow-hidden cursor-pointer hover:bg-background-200/70 transition-colors"
              >
                <div className="w-full h-48 md:h-52 overflow-hidden">
                  <img
                    src={article.image}
                    alt={article.title}
                    className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
                <div className="p-4 md:p-5">
                  <span className="inline-block text-xs font-semibold tracking-wider uppercase text-accent-500 bg-accent-50 px-2.5 py-1 rounded-full mb-2">
                    {article.category}
                  </span>
                  <h3 className="font-heading text-base md:text-lg font-bold text-foreground-950 leading-snug group-hover:text-primary-500 transition-colors">
                    {article.title}
                  </h3>
                  <p className="mt-2 text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-3">
                    {article.excerpt}
                  </p>
                  <span className="mt-3 inline-flex items-center gap-1 text-xs font-medium text-accent-500">
                    Esplora categoria
                    <i className="ri-external-link-line w-3 h-3 flex items-center justify-center"></i>
                  </span>
                </div>
              </a>
            )
          ))}
        </div>
      </div>
    </section>
  );
}